import React from 'react';
import styles from "./SpeciesList.module.scss";
import Create from "@material-ui/icons/Create";
import DeleteOutline from "@material-ui/icons/DeleteOutline";

export const SpeciesList = ({props, speciesHistory, editActionHandler, removeActionHandler}) => { 
  const renderSpeciesHistory = () => {
    // return (
    //   <>
    //     {speciesHistory.map((el, i) => (
    //       <div key={"species-" + i} className={`${styles.editSection}`}>
    //         <>
    //           <div className={"row"}>
    //             <div className={"col-3"}>
    //               <label>Species Code</label>
    //             </div>
    //             <div className={"col-7 " + styles.divContent}>
    //               {el.speciesCode}
    //             </div>
    //             <div className={"col-2 " + styles.editButtonSection}>
    //               <Create
    //                 onClick={() => {
    //                   editActionHandler(i);
    //                 }}
    //               />
    //               <DeleteOutline
    //                 onClick={() => {
    //                   removeActionHandler(i);
    //                 }}
    //               />
    //             </div>
    //           </div>
    //            {el.speciesCommonName && (
    //             <div className={"row"}>
    //               <div className={"col-3"}>
    //                 <label>Common Name</label>
    //               </div>
    //               <div className={"col-7 " + styles.divContent}>
    //                 {el.speciesCommonName}
    //               </div>
    //             </div>
    //           )}
    //          {el.speciesGenus && (
    //             <div className={"row"}>
    //               <div className={"col-3"}>
    //                 <label>Genus</label>
    //               </div>
    //               <div className={"col-7 " + styles.divContent}>
    //                 {el.speciesGenus}
    //               </div>
    //             </div>
    //           )}
    //           {el.species && (
    //             <div className={"row"}>
    //               <div className={"col-3"}>
    //                 <label>Species</label>
    //               </div>
    //               <div className={"col-7 " + styles.divContent}>
    //                 {el.species}
    //               </div>
    //             </div>
    //           )}
    //           {el.subSpecies && (
    //             <div className={"row"}>
    //               <div className={"col-3"}>
    //                 <label>Subspecies</label>
    //               </div>
    //               <div className={"col-7 " + styles.divContent}>
    //                 {el.subSpecies}
    //               </div>
    //             </div>
    //           )}
    //           {el.speciesNoOfFauna && (
    //             <div className={"row"}>
    //               <div className={"col-3"}>
    //                 <label>Number of Fauna</label>
    //               </div>
    //               <div className={"col-7 " + styles.divContent}>
    //                 {el.speciesNoOfFauna}
    //               </div>
    //             </div>
    //           )}              
    //         </>
    //       </div>
    //     ))}
    //   </>
    // );

    return (<div>
      <div className={styles.speciesHistoryTable}>
        <div className={styles.tableHeading + " " + styles.tableRow}>
          <div className={styles.tableColumn}>Species Code</div>
          <div className={styles.tableColumn}>Common Name</div>
          <div className={styles.tableColumn}>Genus</div>
          <div className={styles.tableColumn}>Species</div>
          <div className={styles.tableColumn}>Subspecies</div>
          <div className={styles.tableColumn}>Number of Fauna</div>
        </div>

        {speciesHistory.map((el, i) => (
          <div key={"species-" + i} className={styles.tableRow}>
            <div className={styles.tableColumn}>{el.speciesCode}</div>
            <div className={styles.tableColumn}>{el.speciesCommonName}</div>
            <div className={styles.tableColumn}>{el.speciesGenus}</div>
            <div className={styles.tableColumn}>{el.species}</div>
            <div className={styles.tableColumn}>{el.subspecies}</div>
            <div className={styles.tableColumn}>{el.speciesNoOfFauna}</div>
            <div className={styles.tableColumn + " " + styles.actionColumn}>
              <Create onClick={() => {  
                editActionHandler(i);
              }} />
              <DeleteOutline onClick={() => { removeActionHandler(i)  }} />
            </div>
          </div>
        ))}

      </div>
      {
        speciesHistory.length == 0 && (
          <div key={"species-0"} className={styles.tableRowNodata}>
            <div className={styles.tableColumn}>No species added</div>
          </div>
        )
      }
    </div>
    );
  };

    return (

        <div className={styles.mainCont}>
          <div className={"row"}>
              <div className={"col-12"}>
                {renderSpeciesHistory()}
              </div>
          </div>  
        </div>
         

    )
}